import { useValidations } from "@sttedra_ui/framework";

import { searchValue } from "@/composables/_commons/helper.js";
import { appUserGroupListAll } from "@/api/users-groups/users-groups.api.js";
import { appUserListAll } from "@/api/users/users.api.js";

const { required } = useValidations();

let groups;

// Get the data for the dropdowns
async function getGroups() {
  groups = await appUserGroupListAll({
    filter: "",
    TipoGrupo: 0,
  });
}

export { getGroups };

export default function (object = null, type, isEditing) {
  let passwordRules = isEditing ? null : { required };
  const ministerioRules = type == "ministerio" ? null : { required };

  if (type == "ministerio") {
    passwordRules = null;
  }

  let timeout;

  const emailInput = {
    field: "email",
    label: "Email",
    value: searchValue(object, "email"),
    type: "Autocomplete",
    classObj: ["col-12"],
    properties: {
      forceSelection: false,
      minLength: 3,
      optionLabel: "label",
      placeholder: "Mínimo 3 caracteres",
      suggestions: [],
      delay: 300,
    },
    events: {
      itemSelect: ($event, updateModel, eventHelpers) => {
        eventHelpers?.changeFieldValue("email", $event.value.email);
        eventHelpers?.changeFieldValue("ConfirmEmail", $event.value.email);
      },
      input: async ($event, updateModel) => {
        $event.stopPropagation();
        $event.preventDefault();

        const query = $event.currentTarget.querySelector("input").value.trim();

        if (timeout) {
          clearTimeout(timeout);
        }

        timeout = setTimeout(async () => {
          let suggestions = [];

          if (query && query.length >= 3) {
            suggestions = await appUserListAll({
              email: query,
            });
          }

          updateModel((model) => {
            const formattedSuggestions = suggestions.map((suggestion) => {
              if (suggestion.nombre) {
                return {
                  label: `${suggestion.email} | ${suggestion.nombre}`,
                  email: suggestion.email,
                };
              } else {
                return {
                  label: `${suggestion.email}`,
                  email: suggestion.email,
                };
              }
            });

            model.properties.suggestions = formattedSuggestions;
          });
        }, 600);
      },
    },
  };

  return {
    items: [
      {
        field: "nombre",
        label: "Nombre",
        value: searchValue(object, "nombre"),
        rules: ministerioRules,
        classObj: ["col-12 md:col-6"],
        hidden: type == "ministerio",
      },
      {
        field: "apellido1",
        label: "Primer apellido",
        value: searchValue(object, "apellido1"),
        classObj: ["col-12 md:col-6"],
        hidden: type == "ministerio",
      },
      {
        field: "apellido2",
        label: "Segundo apellido",
        value: searchValue(object, "apellido2"),
        classObj: ["col-12 md:col-6"],
        hidden: type == "ministerio",
      },
      {
        field: "unidad",
        label: "Afiliación/Organismo",
        value: searchValue(object, "unidad"),
        classObj: ["col-12 md:col-6"],
        hidden: type == "ministerio",
      },
      {
        field: "idGrupo",
        label: "Grupo",
        value: searchValue(object, "idGrupo"),
        type: "Multiselect",
        properties: {
          options: groups,
          optionLabel: "nombre",
          optionValue: "idGrupo",
          filter: true,
          disabled: groups?.length == 0,
        },
        classObj: ["col-12 md:col-6"],
        hidden: type == "ministerio",
      },
      {
        field: "habilitadoHasta",
        label: "Habilitado hasta",
        value: isEditing ? searchValue(object, "habilitadoHasta") : 
          (() => {
            const d = new Date();
            d.setMonth(d.getMonth() + 1);
            return d;
          })(),
        type: "calendar",
        rules: { required },
        properties: {
          showTime: true,
          manualInput: false,
        },
        classObj: ["col-12 md:col-6"],
        hidden: type === "ministerio"
      },
      {
        field: "emailTitle",
        classObj: ["col-12 custom-content"],
        hidden: type == "ministerio",
      },
      {
        ...emailInput,
      },
      {
        field: "ConfirmEmail",
        label: "Confirmar email",
        value: searchValue(object, isEditing ? "email" : "ConfirmEmail"),
        rules: ministerioRules,
        classObj: ["col-12"],
        hidden: type == "ministerio",
      },
      {
        field: "passwordTitle",
        classObj: ["col-12 custom-content"],
        hidden: type == "ministerio",
      },
      {
        field: "Contrasena",
        label: "Contraseña",
        value: searchValue(object, "Contrasena"),
        rules: passwordRules,
        type: "password",
        properties: {
          toggleMask: true,
        },
        classObj: ["col-12 md:col-6"],
        hidden: type == "ministerio",
      },
      {
        field: "confirmContrasena",
        label: "Confirmar contraseña",
        value: searchValue(object, "confirmContrasena"),
        rules: passwordRules,
        type: "password",
        properties: {
          toggleMask: true,
        },
        classObj: ["col-12 md:col-6"],
        hidden: type == "ministerio",
      },
      {
        field: "generatePassword",
        classObj: ["col-12 custom-content"],
        hidden: type == "ministerio",
      },
      {
        field: "activo",
        label: "Cuenta habilitada",
        value: searchValue(object, "activo"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "esAdministrador",
        label: "Es administrador",
        value: searchValue(object, "esAdministrador"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
        hidden: type == "individual",
      },
      {
        field: "EnviarEmail",
        label: "Enviar email",
        value: searchValue(object, "EnviarEmail"),
        type: "inputswitch",
        properties: {
          trueValue: true,
          falseValue: false,
        },
        classObj: ["col-12 md:col-4"],
      },
      {
        field: "mensajeEmail",
        label: "Mensaje para el usuario",
        value: searchValue(object, "mensajeEmail"),
        type: "textarea",
        classObj: ["col-12"],
        properties: {
          disabled: true,
        },
      },
    ],
  };
}
